import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { useDestinations } from '_/hooks/useDestinations';
import React, { ReactElement } from 'react';

function DestinationsContainer(): ReactElement {
  const { data: destinations = [], isLoading } = useDestinations();

  return (
    <AsyncPageContainer isLoading={!destinations || isLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
}

export default DestinationsContainer;
